module.exports = __webpack_public_path__ + "img/all-flexi.f5f19845.png";